import {
	PREDEFINED_TREE_NODES, KIND, MIME_TYPE, SEARCH_RESULTS_ID,
} from "./consts";

export const myDrive = {
	[PREDEFINED_TREE_NODES.MY_DRIVE]: {
		id: PREDEFINED_TREE_NODES.MY_DRIVE,
		name: "google_drive.my_drive",
		path: [PREDEFINED_TREE_NODES.MY_DRIVE],
		type: MIME_TYPE.FOLDER,
		kind: KIND.MY_DRIVE,
		children: [],
	},
};

export const sharedDrive = {
	[PREDEFINED_TREE_NODES.SHARED_DRIVE]: {
		id: PREDEFINED_TREE_NODES.SHARED_DRIVE,
		name: "google_drive.shared_drive",
		path: [PREDEFINED_TREE_NODES.SHARED_DRIVE],
		type: MIME_TYPE.FOLDER,
		kind: KIND.SHARED_DRIVE,
		children: [],
	},
};

export const sharedWithMe = {
	[PREDEFINED_TREE_NODES.SHARED_WITH_ME]: {
		id: PREDEFINED_TREE_NODES.SHARED_WITH_ME,
		name: "google_drive.shared_with_me",
		path: [PREDEFINED_TREE_NODES.SHARED_WITH_ME],
		type: MIME_TYPE.FOLDER,
		kind: KIND.SHARED_WITH_ME,
		children: [],
		noChildren: true,
	},
};

export const recent = {
	[PREDEFINED_TREE_NODES.RECENT]: {
		id: PREDEFINED_TREE_NODES.RECENT,
		name: "google_drive.recent",
		path: [PREDEFINED_TREE_NODES.RECENT],
		type: MIME_TYPE.FOLDER,
		kind: KIND.RECENT,
		children: [],
		noChildren: true,
	},
};

export const starred = {
	[PREDEFINED_TREE_NODES.STARRED]: {
		id: PREDEFINED_TREE_NODES.STARRED,
		name: "google_drive.starred",
		path: [PREDEFINED_TREE_NODES.STARRED],
		type: MIME_TYPE.FOLDER,
		kind: KIND.STARRED,
		children: [],
		noChildren: true,
	},
};

export const searchResults = {
	[SEARCH_RESULTS_ID]: {
		id: SEARCH_RESULTS_ID,
		name: "google_drive.search_results",
		path: [SEARCH_RESULTS_ID],
		kind: KIND.SEARCH,
		noChildren: true,
	},
};
